import React, { createContext, useState } from "react";

export const EquipmentContext = createContext();

export const EquipmentProvider = ({ children }) => {

    const [equipment, setEquipment] = useState({});

    const updateEquipment = (tag, updates) => {

        setEquipment(prev => ({

            ...prev,

            [tag]: {

                ...prev[tag],

                ...updates

            }

        }));

    };

    return (

        <EquipmentContext.Provider
            value={{
                equipment,
                updateEquipment
            }}
        >

            {children}

        </EquipmentContext.Provider>

    );

};